module.exports = __webpack_public_path__ + "static/img/wechat-select.ca17e02e.svg";